(function () {
  document.querySelectorAll('[data-product-carousel]').forEach(function (carousel) {
    var slides = carousel.querySelectorAll('[data-slide]');
    var thumbs = carousel.querySelectorAll('[data-thumb]');
    if (!slides.length) return;
    var current = 0;

    var counter = carousel.querySelector('[data-slide-counter]');

    function goTo(index) {
      slides.forEach(function (s, i) { s.classList.toggle('is-active', i === index); });
      thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === index); });
      if (counter) counter.textContent = (index + 1) + ' / ' + slides.length;
      current = index;
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        goTo(parseInt(this.dataset.thumb));
      });
    });

    var prev = carousel.querySelector('[data-carousel-prev]');
    var next = carousel.querySelector('[data-carousel-next]');
    if (prev) prev.addEventListener('click', function () { goTo((current - 1 + slides.length) % slides.length); });
    if (next) next.addEventListener('click', function () { goTo((current + 1) % slides.length); });
  });
})();
